<template>
    <div class="detail-box">
        <div class="detail-top">
            <div class="temple-profile">
                <div class="temple-img">
                    <el-image fit="cover" :src="temple.image" alt=""></el-image>
                </div>
                <div class="temple-name">
                    <div class="name">{{temple.name}}</div>
                    <div class="address">{{temple.address}}</div>
                </div>
            </div>
            <div class="temple-info">
                <div class="title">
                    <i class="iconfont icon-xiangqing"></i>
                    <span>场所简介</span>
                    <el-rate
                        v-model="temple.score"
                        disabled
                        text-color="#ff9900">
                    </el-rate>
                </div>
                <div class="temple-tag">
                    <div class="temple-tag-list">
                        <div class="tag-title">
                            <i class="iconfont icon-shijian green"></i>
                            <span>创建时间</span>
                        </div>
                        <div class="tag-content">{{ temple.building_date ? temple.building_date : '暂无' }}</div>
                    </div>
                    <div class="temple-tag-list">
                        <div class="tag-title">
                            <i class="iconfont icon-gujianzhu11 purple"></i>
                            <span>主要殿堂</span>
                        </div>
                        <div class="tag-content">{{temple.halls}}座</div>
                    </div>
                    <div class="temple-tag-list">
                        <div class="tag-title">
                            <i class="iconfont icon-renqun orange"></i>
                            <span>僧众人数</span>
                        </div>
                        <div class="tag-content">约{{temple.people}}人</div>
                    </div>
                    <div class="temple-tag-list">
                        <div class="tag-title">
                            <i class="iconfont icon-fuwuleixing red"></i>
                            <span>场所类型</span>
                        </div>
                        <div class="tag-content">{{ temple.religious_type_name }} {{ temple.place_type_name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail-content">
            <el-tabs type="card" @tab-click="handleClick">
                <el-tab-pane name="场所详情">
                    <span slot="label"><i class="iconfont icon-xiangqing"></i> 场所详情</span>
                    <div>
                        <place-detail ></place-detail>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="场所订单">
                    <span slot="label"><i class="iconfont icon-5"></i> 场所订单</span>
                    <div>
                        <order-list :id="id"></order-list>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="设备详情">
                    <span slot="label"><i class="iconfont icon-xinpian"></i> 设备详情</span>
                    <div>
                        <equip-detail :temple="id"></equip-detail>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="殿堂信息">
                    <span slot="label"><i class="iconfont icon-gujianzhu11"></i> 殿堂信息</span>
                    <div>
                        <hall-detail :temple="id"></hall-detail>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="我的行程">
                    <span slot="label"><i class="iconfont icon-rizhi"></i> 对接日志</span>
                    <div>
                        <time-line :id="id"></time-line>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import {getListById} from "@/api/temple.js"
    import EquipDetail from "@/components/temple/equipDetail.vue";
    import hallDetail from "@/components/temple/hallDetail.vue"; 
    import placeDetail from "@/components/temple/placeDetail.vue"; 
    import TimeLine from "../components/timeline.vue"
    import OrderList from "../components/order.vue"
    let _this; // 保存this
export default {
    components: {EquipDetail,hallDetail,placeDetail,TimeLine,OrderList},
    props: {
        id:Number
    },
    data() {
        return {
            temple:null,
            equipDrawer:false,
            hallDrawer:false,
            placeDrawer:true,
        };
    },
    computed: {},
    mounted() {
        _this = this;
        // _this.groupID = _this.$store.state.user.userData.group_id
        this.init();
    },
    methods: {
        init() {
            getListById(this.id).then(res=>{
                console.log(res)
                if(res.code === 200){
                    this.temple = res.data;
                }
            })
        },
        handleClick(tab, event) {
            console.log(tab, event);
            if(tab.name === '设备详情'){
                this.equipDrawer = true; 
                this.hallDrawer = false; 
                this.placeDrawer = false;       
            }else if(tab.name === '殿堂信息'){
                this.hallDrawer = true;
                this.equipDrawer = false; 
                this.placeDrawer = false;   
            }else if(tab.name === '场所详情'){
                this.hallDrawer = false;
                this.equipDrawer = false; 
                this.placeDrawer = true;   
            }
        },
        close() {
            _this.$emit("close");
            // _this.$emit("success");
        },
    }
};
</script>

<style lang="scss" scoped>
    .detail-box{
        width: 100%;
        height: 100%;
        overflow: auto;
        box-sizing: border-box;
        padding: 20px;
        background-color: #f0f2f5;
        .detail-top{
            width: 100%;
            height: 480px;
            background-color: #ffffff;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0px 0px 10px 0px rgba(0, 21, 41, 0.1);
            .temple-profile{
                width: 100%;
                height: 300px;
                box-sizing: border-box;
                position: relative;
                .temple-img{
                    width: 100%;
                    height: 100%;
                    box-sizing: border-box;
                    .el-image{
                        width: 100%;
                        height: 100%;
                    }
                }
                .temple-name{
                    width: 100%;
                    height: 100px;
                    background-color: rgba(0,0,0,0.5);
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    box-sizing: border-box;
                    padding: 20px;
                    color: #ffffff;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .name{
                        font-size: 28px;
                        font-weight: bold;
                        width: 100%;
                        margin-bottom:5px;
                    }
                }
            }
            .temple-info{
                width: 100%;
                height: 100px;
                box-sizing: border-box;
                padding: 20px;
                .title{
                    width: 100%;
                    display:inline-flex;
                    align-items: center;
                    i{
                        color:#1890FF;
                    }
                    span{
                        font-size: 20px;
                        font-weight: bold;
                        margin-left: 10px;
                        margin-right: 10px;
                    }
                }
            }
        }
        .detail-content{
            width: 100%;
            box-sizing: border-box;
            background-color: #ffffff;
            border-radius: 20px;
            margin-top: 20px;
            .el-tab-pane{
                padding:0 20px;
            }
            .el-row {
                padding:0 20px;
                margin-top: 20px;
                margin-bottom: 20px;
                &:last-child {
                margin-bottom: 0;
                }
            }
            .el-col {
                border-radius: 4px;
                margin-bottom: 20px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
                border-radius: 10px;
                padding: 0 0 10px 0;
                .content-img{
                    width:100%;
                }
                .content{
                    width:100%;
                    font-size: 14px;
                    padding:10px 10px;
                    .content-title{
                        font-weight: 600;
                        font-size: 18px;
                    }
                    .content-serial{
                    }
                    .content-place{
                        font-weight: 400;
                        display: flex;
                        justify-content: space-between;
                        width:100%;
                        .place-label{
                            color: #666666;
                       }
                       .place-status{
                            font-size: 14px;
                            width:50px;
                            height:25px;
                            line-height:25px;
                            text-align: center;
                            border-radius: 5px;
                            background-color: #0ec79f;
                            color: #067960;
                       }
                       .place-status-error{
                            font-size: 14px;
                            width:70px;
                            height:25px;
                            line-height:25px;
                            text-align: center;
                            border-radius: 5px;
                            background-color: #f0ea96;
                            color: #a1a32a;
                       }
                    }
                }
            }
        }
    }
    .temple-tag{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        justify-content: space-between;
        .temple-tag-list{
            width: 24%;
            height: 100%;
            box-sizing: border-box;
            background-color: #f0f2f5;
            padding: 20px 14px;
            border-radius: 10px;
            .tag-title{
                width: 100%;
                align-items: center;
                span{
                    font-size: 16px;
                    margin-left: 5px;
                }
                .green{
                    color: #0ec79f;
                }
                .orange{
                    color: #ff9900;
                }
                .purple{
                    color: #9933ff;
                }
                .yellow{
                    color: #ffcc00;
                }
                .red{
                    color: #ff3300;
                }
            }
            .tag-content{
                margin-top: 5px;
                font-size: 14px;
                color: #666666;
            }
        }
    }
</style>